import {envIsBeta, envIsDev} from '../../config';
import {useViewer} from '../../state/viewer/hooks';
import {isCoreWeaveDomainEmail, isWandbDomainEmail} from '../../util/admin';

/**
 * Prefix marking a control as internal-only. Prepended to each control's own
 * tooltip (via {@link internalTooltip}) so they don't read as customer features
 * while keeping their descriptive hover text.
 */
export const INTERNAL_FEATURE_PREFIX = 'Internal Feature: ';

/**
 * internalTooltip prefixes a control-specific tooltip with the internal marker,
 * e.g. `internalTooltip('Pick agent')` → "Internal Feature: Pick agent".
 */
export function internalTooltip(detail: string): string {
  return `${INTERNAL_FEATURE_PREFIX}${detail}`;
}

/**
 * useIsInternalUser gates internal-only WBAgent controls: anyone on a beta/dev
 * build, plus W&B and CoreWeave employees on any environment.
 */
export function useIsInternalUser(): boolean {
  const viewer = useViewer();
  const email = viewer?.email ?? '';
  return (
    envIsDev ||
    envIsBeta ||
    isWandbDomainEmail(email) ||
    isCoreWeaveDomainEmail(email)
  );
}
